import { useLayoutEffect, useRef } from 'react';

export interface Latest<T> {
  readonly current: T;
}

export const useLatest = <T>(value: T): Latest<T> => {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
};
